import {
  imageBakery,
  imageBraintree,
  imageDupay,
  imageMercadoPago,
  imageMultiBanco,
  imagePagarme,
  imagePaymentsWay,
  imagePaypal,
  imagePayu,
  imageStripe,
  imageT3Pay,
  imageUnicef
} from "../assets/gateways/gatewayImages";

export default {
  methods: {
    getGatewayImageByName(gateway) {
      const PAYMENTS_WAY = "Bakery";
      const RECURRENT_PAYMENTS = "Recurrent Payments";
      const BRAINTREE = "Braintree";
      const DUPAY = "Dupay";
      const MERCADO_PAGO = "MercadoPago";
      const MULTI_BANCO = "MultiBanco";
      const PAGARME = "Pagarme";
      const PAYPAL = "Paypal";
      const PAYU = "Payu";
      const STRIPE = "Stripe";
      const T3_PAY = "T3Pay";
      const UNICEF = "Unicef";

      switch (gateway) {
        case PAYMENTS_WAY:
        case RECURRENT_PAYMENTS:
          return imagePaymentsWay;
        case BRAINTREE:
          return imageBraintree;
        case DUPAY:
          return imageDupay;
        case MERCADO_PAGO:
          return imageMercadoPago;
        case MULTI_BANCO:
          return imageMultiBanco;
        case PAGARME:
          return imagePagarme;
        case PAYPAL:
          return imagePaypal;
        case PAYU:
          return imagePayu;
        case STRIPE:
          return imageStripe;
        case T3_PAY:
          return imageT3Pay;
        case UNICEF:
          return imageUnicef;
        default:
          return null;
      }
    }
  }
};
